export const enum CategorySourceEnum {
    CUSTOM = 'custom',
    SERVICE = 'service'
}